import React from "react";

import { Props } from "./types";
import { Skeleton } from "@common/skeleton";
import styles from "./styles.scss";

function Comment(_: Props) {
  return (
    <div className={styles.comment}>
      <Skeleton className={styles.avatar} />
      <Skeleton className={styles.main} />
    </div>
  );
}

export { Comment };
